module.exports = __webpack_public_path__ + "static/media/elvan-03.9fc2deb9.jpg";